export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14068.6c76c623.jpg";